import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import ActivityOption from '../activityOption/ActivityOption';
import { getDayLabel, entertainmentDetailsPage } from '../../utils';
import './EntertainmentCategory.scss';

const getEventCheckedStatus = (bookedEvents, slots) => {
  const result = {
    color: '',
    time: '',
  };
  if (!bookedEvents || bookedEvents.length === 0 || !slots || slots.length === 0) {
    return result;
  }
  slots.forEach(({ Id: slotId }) => {
    bookedEvents.forEach(({ id: bookedId, slotColor, startTime }) => {
      if (slotId === parseInt(bookedId, 10)) {
        result.color = slotColor;
        result.time = startTime;
      }
    });
  });
  return result;
};

const findBookedEvent = ({ slots = [] }, bookedEvents) => {
  let bookedEvent = null;
  slots.forEach(({ Id }) => {
    const event = bookedEvents.find(({ id }) => {
      const slotId = parseInt(id, 10);
      return slotId === Id;
    });
    if (!event) return;
    bookedEvent = { ...event };
  });
  return bookedEvent;
};

const sortBookedEvents = (eventA, eventB, bookedEvents) => {
  const bookedA = findBookedEvent(eventA, bookedEvents);
  const bookedB = findBookedEvent(eventB, bookedEvents);

  if (!bookedA && !bookedB) return 0;
  if (!bookedA && !!bookedB) return 1;
  if (!!bookedA && !bookedB) return -1;

  const { startTime: startTimeA = '' } = bookedA;
  const { startTime: startTimeB = '' } = bookedB;
  const [startHourAString = '', startMinuteAString = ''] = startTimeA.split(':');
  const [startHourBString = '', startMinuteBString = ''] = startTimeB.split(':');
  const startHourA = parseInt(startHourAString, 10);
  const startMinuteA = parseInt(startMinuteAString, 10);
  const startHourB = parseInt(startHourBString, 10);
  const startMinuteB = parseInt(startMinuteBString, 10);

  if (startHourA < startHourB) return -1;
  if (startHourA > startHourB) return 1;
  if (startMinuteA < startMinuteB) return -1;
  if (startMinuteA > startMinuteB) return 1;

  return 0;
};

const getSortedEvents = (events, bookedEvents) => {
  const sortedEvents = [...events];
  sortedEvents.sort((eventA, eventB) => sortBookedEvents(eventA, eventB, bookedEvents));
  return sortedEvents;
};

const EntertainmentCategory = ({
  date,
  categoryIndex = 0,
  events = [],
  bookedEvents = [],
  detailPage = entertainmentDetailsPage,
}) => {
  const sortedEvents = getSortedEvents(events, bookedEvents);
  return (
    <div className="entertainment">
      <div className="date">
        <div className="day-container">
          <div className={classnames('day-name', `date-color-${categoryIndex + 1}`)}>{getDayLabel(date)}</div>
        </div>
      </div>
      <div className="containers">
        {!!sortedEvents && sortedEvents.map(({ code, name, location, slots }) => {
          const { color, time } = getEventCheckedStatus(bookedEvents, slots);
          const slotTimes = slots.map(({ Starts }) => moment(Starts).format('HH:mm'));
          const slotTimesString = slotTimes.length > 4 ? `${slotTimes.slice(0, 4).join(', ')} ...` : slotTimes.join(', ');
          return (
            <ActivityOption
              key={code}
              color={color}
              redirectPath={`${detailPage}&entertainmentId=${code}`}
              name={name}
              location={location}
              time={time}
              slotTimesString={slotTimesString}
            />
          );
        })}
      </div>
    </div>
  );
};

EntertainmentCategory.propTypes = {
  categoryIndex: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  events: PropTypes.array.isRequired,
  bookedEvents: PropTypes.array,
  detailPage: PropTypes.string,
};

export default EntertainmentCategory;
